<template>
  <div class="mb-base">
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce contact ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="acceptDelete()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="declineDelete()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
	<FilterCard :refreshKey="1" :filters="filtersTemplates" showRowNum="false" :showListLength="displaySocieties(contacts).length" @filter="handleFilterEmits($event)" :actions="actionsTemplates" @action="handleActionEmits($event)" :onChangeEmit="true" />

    <vx-card style="max-height:69vh; overflow: auto;">
      <div class="vx-row mt-1" style=" display: flex; align-items: stretch;">
        <div
          class="vx-col mb-base"
          v-for="(contact, index) in displaySocieties(contacts)"
          :key="index"
          style="flex: 1 0;"
        >
          <!-- CONTACT CARD -->
          <vx-card class="p-2 inheritH" style="height: 100%;">
            <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
              <div>
                <!-- AVATAR -->
                <!-- <div class="vx-row">
                  <vs-avatar
                    class="mx-auto mb-6 block"
                    size="80px"
                  />
                </div> -->
                <!-- FULL NAME & TITLE -->
                <div class="vx-row  mx-auto justify-center">
                  <div class="text-center">
                    <h4>{{ contact.firstname }} {{ contact.lastname }}</h4>
                  </div>
                </div>
                <!-- PHONE -->
                <div class="vx-row mt-2 flex justify-between">
                  <div class="flex items-center" style="flex: 1 0;">
                    <span class="ml-2">Tél : {{ contact.phone }}</span>
                  </div>
                </div>
                <!-- MAIL -->
                <div class="vx-row flex justify-between">
                  <div class="flex items-center" style="flex: 1 0;">
                    <span class="ml-2">Email : {{ contact.email }}</span>
                  </div>
                </div>
                <div class="vx-row flex justify-between">
                  <div class="flex items-center" style="flex: 1 0;">
                    <vs-table stripe
                      :data="contact.societiesTypes"
                      style="flex: 1 0;"
                    >

                      <template slot="thead">
                        <vs-th class="bgcolor white-txt">Société</vs-th>
                        <vs-th class="bgcolor white-txt">Type</vs-th>
                        <vs-th class="bgcolor white-txt">Fonction</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="index" v-for="(row, index) in data">
                          <vs-td>{{ getSocietyName(row.society) }}</vs-td>
                          <vs-td>{{ getUserTitle(row.type) }}</vs-td>
                          <vs-td style="text-transform: capitalize;">{{ row.fonction }}</vs-td>
                        </vs-tr>
                      </template>

                    </vs-table>
                  </div>
                </div>
                <!-- COMMENT -->
                <!-- <div class="vx-row flex justify-between">
                  <div class="flex items-center">
                    <span class="ml-2">Commentaire : {{ contact.commentary }}</span>
                  </div>
                </div> -->
                <!-- BUTTONS -->
              </div>
              <div
                class="flex justify-between flex-wrap"
                v-if="$acl.check('commercial')"
              >
                <vs-button
                  v-if="$acl.check('sadmin')"
                  class="mt-4 mr-2"
                  type="border"
                  color="danger"
                  @click="deleteContact(contact.id)"
                  >Supprimer</vs-button
                >
                <vs-button
                  color="primary"
                  class="mt-4 shadow-lg"
                  @click="modifyContact(contact.id, contact.societies_id)"
                >Modifier
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import store from "@/store/store";
import fieldConvertorMixin from "@/mixins/dbFieldConvertorMixin";
import FilterCard from "@/views/filters/FilterCard";
import utilsMixin from "@/mixins/utilsMixin";
import XLSX from "xlsx";

export default {
	name: "ContactsDashboard",
	mixins: [fieldConvertorMixin, utilsMixin],
	components: {FilterCard},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			nameFilter: "",
			societyFilter: "",
			activeFilter: false,
			functionFilter: 0,
			nameFilterOn: false,
			societyFilterOn: false,
			activeFilterOn: false,
			functionFilterOn: false,
			//contacts: new Array() // Array<Contact>
			displayedContacts: [],
			displayedContactsLength: 0,
			// FORM SELECT OPTIONS
			typeOptions: [
				{text: "Facturation", value: 1},
				{text: "Commercial", value: 2},
				{text: "Technique", value: 5}
			],
			showValidationPopup: false,
			selectedContact: null,
			actionsTemplates: [{
				order: 1,
				emitSlugName: "action_extract_contact",
				buttonName: "Exporter",
				buttonIcon: "",
				buttonColor: "dark",
			}, ],
			filtersTemplates: [{
				order: 1, 
				emitSlugName: "filter_name",
				filterPlaceHolder: "Prénom Nom",
				value: "", 
				type: "Input",
			},
			{
				order: 2,
				emitSlugName: "filter_client",
				filterPlaceHolder: "Client",
				value: "",
				type: "Input",
			}, {
				order: 3,
				emitSlugName: "filter_type",
				filterPlaceHolder: "Type de contact",
				value: "",
				type: "Dropdown",
				params: {
					autocomplete: true,
					dropdownValues: [
						{name: "Facturation", id: 1},
						{name: "Commercial", id: 2},
						{name: "Technique", id: 5}
					]
				}
			}]
		};
	},
	created() {
		this.getAllContacts();
	},
	watch: {
		nameFilter: function() {
			if(this.nameFilter == "") {
				this.nameFilterOn = false;
			}
			else{
				this.nameFilterOn = true;
			}
			this.displayedContacts = this.filterContacts(this.contacts); //A CHANGER
		},
		societyFilter: function() {
			if(this.societyFilter == "") {
				this.societyFilterOn = false;
			}
			else{
				this.societyFilterOn = true;
			}
			this.displayedContacts = this.filterContacts(this.contacts); //A CHANGER
		},
		activeFilter: function() {
			this.activeFilterOn = true;
			this.displayedContacts = this.filterContacts(this.contacts); //A CHANGER
		},
		functionFilter: function() {
			if(this.functionFilter == 0) {
				this.functionFilterOn = false;
			}
			else{
				this.functionFilterOn = true;
			}
			this.displayedContacts = this.filterContacts(this.contacts); //A CHANGER
		},
		displayedContacts: function() {
			this.displayedContactsLength = this.displayedContacts.length;
		},
		contacts: function() {
			this.displayedContactsLength = this.contacts.length;
		},
	},
	computed: {
		contacts: function() {
			return this.$store.state.contacts;
		},
		societies: () => {
			return store.state.societies;
		}
	},
	methods: {
		/**
		 * Fetch all the contacts
		 */
		getAllContacts() {
			this.$store.dispatch("getAllContacts");
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(row => row.emitSlugName == receivedEmit[0]);
			if(templateRowIndex >= 0) this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch(receivedEmit[0]){
			case"filter_client":
				this.societyFilter = receivedEmit[1].value;
				break;
			case"filter_name":
				this.nameFilter = receivedEmit[1].value;
				break;
			case"filter_type":
				this.functionFilter = receivedEmit[1].value;
				break;
			default:
				break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			switch(receivedEmit[0]){
			case"action_extract_contact":
				this.exportData(this.contacts);
				break;
			default:
				break;
			}
		},

		/**
		 * Open form to modify the collaborator passed in argument
		 * @param {Number} contactId - Contact ID to modify
		 */
		modifyContact(contactId, societyId){
			let updateEntityForm = "contact";
			this.$router.push({name: "update_entity", params: {contactId, societyId, updateEntityForm}});
			//console.log("modifyContact");
		},

		/**
		 * Open form to delete the collaborator passed in argument
		 * @param {Number} contactId - Contact ID to delete
		 */
		deleteContact(contactId){
			this.$http.delete(this.apiUrl + "users/delete", {
				data: {
					id: contactId
				}
			})
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Contact effacé avec succès."
					});
					// Refresh List
					this.refreshContact();
				})
				.catch(err => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Le contact n'a pas été effacé."
					});
				});
		},

		displayValidationPopup(contactId){
			this.selectedContact = contactId;
			this.showValidationPopup = true;
		},

		acceptDelete(){
			this.deleteContact(this.selectedContact);
			this.showValidationPopup = false;
		},

		declineDelete(){
			this.selectedContact = null;
			this.showValidationPopup = false;
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			if(this.commercialFilterOn || this.societyFilterOn || this.activeFilterOn || this.functionFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered contacts A CHANGER
		 * @param {Boolean} activeFilter - Society is active?
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} commercialFilter - Id of the commercial in charge of the project
		 * @return {List} - Societies' list filtered
		 */
		filterContacts(contacts){
			let contactsList = [];

			let searchKeyList = {};
			this.societyFilterOn ? searchKeyList["societyFilter"] = this.societyFilter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
			this.nameFilterOn ? searchKeyList["nameFilter"] = this.nameFilter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
			this.functionFilterOn ? searchKeyList["functionFilter"] = this.functionFilter : false;

			for(let contactToFilter of contacts){
				let society_name = this.getSocietyName(contactToFilter.societies_id);
				let name = "";

				if(society_name != "") society_name = society_name.toLowerCase();
				if(contactToFilter.firstname) name += contactToFilter.firstname.toLowerCase();
				if(contactToFilter.lastname) name += contactToFilter.lastname.toLowerCase();

				let contactSearchKeyList = {};
				this.societyFilterOn ? contactSearchKeyList["societyFilter"] = society_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
				this.nameFilterOn ? contactSearchKeyList["nameFilter"] = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
				this.functionFilterOn ? contactSearchKeyList["functionFilter"] = contactToFilter.type : false;

				let check = true;

				for(let key in searchKeyList) {
					if(typeof searchKeyList[key] == "string"){
						if(!contactSearchKeyList[key].includes(searchKeyList[key])){
							check = false;
							break;
						}
					}
					else{
						if(contactSearchKeyList[key] != searchKeyList[key]){
							check = false;
							break;
						}
					}
				}

        if(check) contactsList.push(contactToFilter);
      }
      //return result
      return contactsList
    },
    /**
     * Return list of societies to display
     * @return {List} - societies to display
     */
    displaySocieties(contacts){
      let contactsList = []
      if(this.displayedContacts.length > 0){
            contactsList = this.displayedContacts
      }else{
        if(this.isFilterSet()){
          //console.log("1", contactsList)
          return contactsList
        }else{
          //console.log("2", contacts)
          return contacts
        }
      }

      //return result
      //console.log("3", contactsList)
      return contactsList;
    },
    /**
     * Gets society name from Id
     * @param {Number} societyId - Society's ID to get name from
     * @return {String} - Returns Society's name
     */
    getSocietyName(societyId){
      for(let society of this.$store.state.societies){
        if(societyId == society.id){
          return society.name
        }
      }
      return "Entreprise non renseignée"
    },
    /**
     * Gets society name from Id
     * @param {Number} societyId - Society's ID to get name from
     * @return {String} - Returns Society's name
     */
    getSocietyNameFilter(societyId){
			for(let society of this.$store.state.societies){
				//console.log(societyId);
				//console.log(society.id);
				if(societyId == society.id){
					return society.name;
				}
			}
			return "";
		},
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				data[i]["status"] = this.getStatus(data[i]["status"]);
				data[i]["type"] = this.getContactType(data[i]["type"]);
				data[i]["civility"] = this.getUserCivility(data[i]["civility"]);
				data[i]["societies_id"] = this.research(data[i]["societies_id"], this.societies, "id", "name");

				if(data[i]["phone"] !== null){
					data[i]["phone"] = data[i]["phone"].replace(/\s*/g, "");
					data[i]["phone"] = data[i]["phone"].replace("(0)", "0");
					data[i]["phone"].length == 9 ? data[i]["phone"] = "0" + data[i]["phone"]: "";
				}

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}
			}

			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Contrats";

			let header = {
				header: [
					"id",
					"firstname",
					"lastname",
					"type",
					"civility",
					"email",
					"phone",
					"status",
					"societies_id",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				id: "Identifiant",
				firstname: "Prénom",
				lastname: "Nom",
				type: "Type de contact",
				civility: "Civilité",
				email: "Email",
				phone: "Téléphone",
				status: "Statut",
				societies_id: "Société",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Contacts_export.xls");
		},
	}
};
</script>
<style lang="scss">
.inheritH > div{
  height: 100%;
}
.inheritH > div > div{
  height: 100%;
}
.table-filter{
	.con-tablex.vs-table--content{
		.vs-con-tbody.vs-table--tbody > table{
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead{
				display: none;
			}
			tr{
				.td-check{
					width: 40px;
				}
				td{
					border: none;
				}
			}
			.tr-expand > td > div{
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table{
				display: none;
			}
		}
		.not-data-table.vs-table--not-data{
			display: none;
		}
	}
}
</style>